import React from "react";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";

const FeatureBanner = () => {
  const { t } = useTranslation("features");

  return (
    <div className="bg-purple-800 py-12 lg:pb-52">
      <section className="container flex items-center justify-between gap-4">
        <div className="z-10 w-1/2 max-w-2xl space-y-3 lg:space-y-6 xl:w-2/5 2xl:w-auto">
          <h1 className="first-line:text-gradient font-title text-2xl font-bold md:text-3xl lg:text-6xl">
            {t`features:title`}
          </h1>
          <p className="text-xs leading-5 text-grey-800 md:text-lg lg:text-xl lg:leading-[2.25rem]">{t`subtitle`}</p>
          <Link href="/register">
            <a className="button-lg inline-flex items-center gap-3">
              <Image src="/icon-sign-up.svg" alt="Sign up icon" width={24} height={24} />
              {t`button`}
            </a>
          </Link>
        </div>
        <div className="ml-[-50%] flex-1 self-end md:ml-[-20%] md:translate-x-0 xl:ml-0 xl:w-1/2 xl:flex-none">
          <div className="relative w-full pb-[80%]">
            <div className="absolute inset-0 h-full w-full">
              <div
                style={{ backgroundImage: "url('/features/banner.png')" }}
                className="h-full animate-fade-in bg-contain bg-rightLittle bg-no-repeat object-cover object-top md:bg-right"
              />
            </div>
            <div className="absolute bottom-0 left-0 z-10 hidden hidden w-48 rotate-12 flex-col rounded-lg bg-white p-6 lg:flex">
              <div className="flex shrink-0">
                <Image src="/home/hero/video.svg" width={149} height={80} alt="Video Icon" />
              </div>
              <div className="mt-5">
                <div className="text-center font-sans text-base font-semibold">{t`mini-card.video.title`}</div>
                <p className="mt-1 text-center font-sans text-xs leading-5 text-grey-700">
                  {t`mini-card.video.description`}
                </p>
              </div>
            </div>
            <div className="absolute bottom-0 right-0 z-10 hidden w-72 -rotate-12 items-center rounded-lg bg-white p-3 lg:flex">
              <div className="absolute -top-7 -right-7 z-10">
                <Image src="/home/hero/chat-2.svg" alt="Message Icon" width={48} height={48} />
              </div>

              <div className="mr-3 flex shrink-0">
                <Image src="/home/hero/chat.svg" width={60} height={80} alt="Note Icon" />
              </div>
              <div className="flex flex-col space-y-1">
                <div className="font-sans text-base font-semibold"> {t`mini-card.chat.title`}</div>
                <p className="font-sans text-xs text-grey-700">{t`mini-card.chat.description`}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FeatureBanner;
